import {
  FaArrowLeft,
  FaBell,
  FaPhone,
  FaVideo,
  FaVolumeMute,
} from 'react-icons/fa';
import { SiWhatsapp } from 'react-icons/si';

import { BrandColors } from 'constants/brand-colors';

import theoPhoto from 'assets/avatars/whatsapp.jpg';

import { SOCIAL_ICON_LG_PX, SOCIAL_ICON_MD_PX } from '../constants';
import * as styled from '../styles/social-bios';
import { AnimatedLinkBox } from './animated-link-box';

export const WhatsAppCard = ({
  initials,
  name,
  profession,
  slug,
  phase,
  enterDelay,
}: Landing.SocialBioCardContent & {
  phase: Landing.SocialBioPhase;
  enterDelay: number;
}) => (
  <styled.Card $isGood={phase === 'good'}>
    <styled.WaHeader>
      <styled.ChromeIconCluster>
        <FaArrowLeft size={SOCIAL_ICON_MD_PX} color="#FFFFFF" />
        <span style={{ fontWeight: 600 }}>Contact info</span>
      </styled.ChromeIconCluster>
      <SiWhatsapp size={SOCIAL_ICON_LG_PX} color="#FFFFFF" />
    </styled.WaHeader>
    <styled.WaIdentity>
      <styled.Avatar
        $size={6}
        $accent={BrandColors.whatsapp}
        $photoUrl={theoPhoto}
      >
        {initials}
      </styled.Avatar>
      <styled.WaName>{name}</styled.WaName>
      <styled.WaPhone>+27 82 555 0142</styled.WaPhone>
    </styled.WaIdentity>
    <styled.WaActionRow>
      <styled.WaActionTile>
        <FaPhone size={SOCIAL_ICON_MD_PX} />
        Audio
      </styled.WaActionTile>
      <styled.WaActionTile>
        <FaVideo size={SOCIAL_ICON_MD_PX} />
        Video
      </styled.WaActionTile>
      <styled.WaActionTile>
        <FaVolumeMute size={SOCIAL_ICON_MD_PX} />
        Mute
      </styled.WaActionTile>
      <styled.WaActionTile>
        <FaBell size={SOCIAL_ICON_MD_PX} />
        Alerts
      </styled.WaActionTile>
    </styled.WaActionRow>
    <styled.WaDivider />
    <styled.WaSectionLabel>About</styled.WaSectionLabel>
    <styled.WaAboutBlock>
      <styled.WaAboutText>{profession}</styled.WaAboutText>
      <AnimatedLinkBox phase={phase} slug={slug} enterDelay={enterDelay} />
    </styled.WaAboutBlock>
  </styled.Card>
);
